import { render, staticRenderFns } from "./TreasuriesTransactions.vue?vue&type=template&id=f37f4afe&"
import script from "./TreasuriesTransactions.vue?vue&type=script&lang=js&"
export * from "./TreasuriesTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports